import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=392c4ab6&scoped=true"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"
import style0 from "./BoardDetail.vue?vue&type=style&index=0&id=392c4ab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c4ab6",
  null
  
)

export default component.exports